export default __webpack_public_path__ + "static/media/OBSERVATION-SUR LE PATRIMOINE-NATUREL.8bf3428e.svg";